// ============================================================
// CaseClaimTypeItem.tsx — the case list card's claim type: a quiet item in
// the card's details row (the same style as Accident / Limitation — an icon
// and plain text, not a badge), with the SHORT label (utils/claimTypes
// CLAIM_TYPE_SHORT_LABELS) and the full name on hover. Nothing when the case
// has no type (older cases).
// ============================================================
import React from 'react'
import { claimTypeLabel, claimTypeShortLabel } from '../../utils/claimTypes'

const CaseClaimTypeItem: React.FC<{ claimType: string | null | undefined }> = ({ claimType }) => {
  const short = claimTypeShortLabel(claimType)
  if (!short) return null
  return (
    <span className="inline-flex items-center gap-1.5" title={claimTypeLabel(claimType) ?? undefined}>
      {/* Tag icon — Feather-style line, as the card's other items. */}
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
        className="w-3.5 h-3.5 shrink-0" aria-hidden="true">
        <path d="M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z" /><circle cx="7.5" cy="7.5" r="1.5" />
      </svg>
      <span className="sr-only">Claim type: </span>{short}
    </span>
  )
}

export default CaseClaimTypeItem
